import { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

gsap.registerPlugin(ScrollTrigger);

export default function Footer() {
  const root = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const el = root.current;
    if (!el) return undefined;
    const mm = gsap.matchMedia();
    mm.add('(prefers-reduced-motion: no-preference)', () => {
      const ctx = gsap.context(() => {
        gsap.fromTo('.footer-mark', { xPercent: -6 }, {
          xPercent: 0, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom bottom', scrub: true },
        });
      }, el);
      return () => ctx.revert();
    });
    return () => mm.revert();
  }, []);

  return (
    <footer ref={root} className="bg-foreground-950 text-background-50 pt-14 md:pt-16 pb-6 overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 px-4 md:px-6">
        <p className="md:col-span-5 text-lg md:text-xl font-semibold leading-snug max-w-[400px]">
          We concept, design and produce remarkable experiences for people and brands.
        </p>
        <nav className="md:col-span-4 md:col-start-7" aria-label="Footer">
          <ul className="flex flex-wrap gap-x-6 gap-y-2">
            {navLinks.map((l) => (
              <li key={l.href}><Link to={l.href} className="text-sm hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer">{l.label}</Link></li>
            ))}
          </ul>
        </nav>
        <Link to="/contact" className="md:col-span-2 md:justify-self-end text-sm hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer">
          Project inquiry <i className="ri-arrow-right-up-line" />
        </Link>
      </div>

      <div aria-hidden className="mt-12 md:mt-16 overflow-hidden">
        <p className="footer-mark whitespace-nowrap text-center font-heading font-extrabold uppercase tracking-[-0.065em] leading-[0.8] text-[15vw]">
          Form <span className="text-primary-500">&amp;</span> Feel
        </p>
      </div>

      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-3 border-t border-background-50/15 px-4 md:px-6 pt-5 text-xs text-foreground-400">
        <p>&copy; 2026 FORM &amp; FEEL. All rights reserved.</p>
        <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="w-fit text-left hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Back to top <i className="ri-arrow-up-line" /></button>
      </div>
    </footer>
  );
}